import RARCS_JSON from './json/RARCS.json'

export const RARCS: Array<{
  code: string
  description: string
  label: string
  phase?: string[]
  outcome?: string[]
  reason?: string[]
  occurrences?: number
}> = RARCS_JSON
